import React from 'react';
import { HStack, Text } from 'native-base';
import { UserAvatar } from '../..';
import { theme } from '@breakroom-nx/assets';
export interface UserListTableViewCellProps {
  uid: string;
  username: string;
  mb?: number;
}

export function UserListTableViewCell({
  uid,
  username,
  mb = 0,
}: UserListTableViewCellProps) {
  return (
    <HStack
      alignItems={'center'}
      rounded={'lg'}
      space={4}
      p={5}
      mb={mb}
      bg={theme.colors.surface[200]}
    >
      <UserAvatar uid={uid} size={45} noBorder />
      <Text
        fontSize={16}
        variant={'usernameProfile'}
        color={'white'}
        isTruncated
      >
        {username}
      </Text>
    </HStack>
  );
}

export default React.memo(UserListTableViewCell);
